/* tslint:disable */
/**
* @module SDKModule
* @author Jonathan Casarrubias <t:@johncasarrubias> <gh:jonathan-casarrubias>
* @license MIT 2016 Jonathan Casarrubias
* @version 2.1.0
* @description
* The SDKModule is a generated Software Development Kit automatically built by
* the LoopBack SDK Builder open source module.
*
* The SDKModule provides Angular 2 >= RC.5 support, which means that NgModules
* can import this Software Development Kit as follows:
*
*
* APP Route Module Context
* ============================================================================
* import { NgModule }       from '@angular/core';
* import { BrowserModule }  from '@angular/platform-browser';
* // App Root 
* import { AppComponent }   from './app.component';
* // Feature Modules
* import { SDK[Browser|Node|Native]Module } from './shared/sdk/sdk.module';
* // Import Routing
* import { routing }        from './app.routing';
* @NgModule({
*  imports: [
*    BrowserModule,
*    routing,
*    SDK[Browser|Node|Native]Module.forRoot()
*  ],
*  declarations: [ AppComponent ],
*  bootstrap:    [ AppComponent ]
* })
* export class AppModule { }
*
**/
import { ErrorHandler } from './services/core/error.service';
import { LoopBackAuth } from './services/core/auth.service';
import { LoggerService } from './services/custom/logger.service';
import { SDKModels } from './services/custom/SDKModels';
import { InternalStorage, SDKStorage } from './storage/storage.swaps';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CookieBrowser } from './storage/cookie.browser';
import { StorageBrowser } from './storage/storage.browser';
import { SocketBrowser } from './sockets/socket.browser';
import { SocketDriver } from './sockets/socket.driver';
import { SocketConnection } from './sockets/socket.connections';
import { RealTime } from './services/core/real.time';
import { EmailApi } from './services/custom/Email';
import { RoleDataApi } from './services/custom/RoleData';
import { UserDataApi } from './services/custom/UserData';
import { UserRoleApi } from './services/custom/UserRole';
import { PartnerApi } from './services/custom/Partner';
import { StandardDiscountApi } from './services/custom/StandardDiscount';
import { ProductApi } from './services/custom/Product';
import { ProductImageApi } from './services/custom/ProductImage';
import { OrderApi } from './services/custom/Order';
import { OrderItemApi } from './services/custom/OrderItem';
import { ConfigurationApi } from './services/custom/Configuration';
import { CommissionApi } from './services/custom/Commission';
import { ActivationApi } from './services/custom/Activation';
import { PaymentApi } from './services/custom/Payment';
import { CardApi } from './services/custom/Card';
import { AgentCommissionApi } from './services/custom/AgentCommission';
import { BankTransactionApi } from './services/custom/BankTransaction';
import { UploadApi } from './services/custom/Upload';
import { TermsAndConditionApi } from './services/custom/TermsAndCondition';
import { CommissionUploadApi } from './services/custom/CommissionUpload';
import { DiscountApi } from './services/custom/Discount';
import { DiscountRequestApi } from './services/custom/DiscountRequest';
import { OtherOrderApi } from './services/custom/OtherOrder';
import { OtherOrderItemApi } from './services/custom/OtherOrderItem';
import { OtherPaymentApi } from './services/custom/OtherPayment';
import { VolumeDiscountApi } from './services/custom/VolumeDiscount';
import { VolumeDiscountRateApi } from './services/custom/VolumeDiscountRate';
import { VolumeDiscountRateRequestApi } from './services/custom/VolumeDiscountRateRequest';
import { AuditTrailApi } from './services/custom/AuditTrail';
import { DiscountLimitApi } from './services/custom/DiscountLimit';
import { UserPasswordApi } from './services/custom/UserPassword';
import { AmazonS3Api } from './services/custom/AmazonS3';
/**
* @module SDKBrowserModule
* @description
* This module should be imported when building a Web Application in the following scenarios:
*
*  1.- Regular web application
*  2.- Angular universal application (Browser Portion)
*  3.- Progressive applications (Angular Mobile, Ionic, WebViews, etc)
**/
@NgModule({
  imports:      [ CommonModule, HttpClientModule ],
  declarations: [ ],
  exports:      [ ],
  providers:    [
    ErrorHandler,
    SocketConnection
  ]
})
export class SDKBrowserModule {
  static forRoot(internalStorageProvider: any = {
    provide: InternalStorage,
    useClass: CookieBrowser
  }): ModuleWithProviders {
    return {
      ngModule  : SDKBrowserModule,
      providers : [
        LoopBackAuth,
        LoggerService,
        SDKModels,
        RealTime,
        EmailApi,
        RoleDataApi,
        UserDataApi,
        UserRoleApi,
        PartnerApi,
        StandardDiscountApi,
        ProductApi,
        ProductImageApi,
        OrderApi,
        OrderItemApi,
        ConfigurationApi,
        CommissionApi,
        ActivationApi,
        PaymentApi,
        CardApi,
        AgentCommissionApi,
        BankTransactionApi,
        UploadApi,
        TermsAndConditionApi,
        CommissionUploadApi,
        DiscountApi,
        DiscountRequestApi,
        OtherOrderApi,
        OtherOrderItemApi,
        OtherPaymentApi,
        VolumeDiscountApi,
        VolumeDiscountRateApi,
        VolumeDiscountRateRequestApi,
        AuditTrailApi,
        DiscountLimitApi,
        UserPasswordApi,
        AmazonS3Api,
        internalStorageProvider,
        { provide: SDKStorage, useClass: StorageBrowser },
        { provide: SocketDriver, useClass: SocketBrowser }
      ]
    };
  }
}
/**
* Have Fun!!!
* - Jon
**/
export * from './models/index';
export * from './services/index';
export * from './lb.config';
export * from './storage/storage.swaps';
export { CookieBrowser } from './storage/cookie.browser';
export { StorageBrowser } from './storage/storage.browser';

